module.exports = __webpack_public_path__ + "static/media/m_beard_medium_diamond__v_shadow.e6b38cf7.png";